module.exports = __webpack_public_path__ + "static/media/ios-create.5290b1ac.svg";